import { render } from "./FairBattles.vue?vue&type=template&id=5014da94&scoped=true"
import script from "./FairBattles.vue?vue&type=script&lang=js"
export * from "./FairBattles.vue?vue&type=script&lang=js"

import "./FairBattles.vue?vue&type=style&index=0&id=5014da94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5014da94"]])

export default __exports__